export default __webpack_public_path__ + "static/media/highlight.a25e0f85.svg";